
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { blockConfig } from "../config/blockConfig";
import type { Block } from "../types";

interface AddBlockDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onAddBlock: (type: Block["type"]) => void;
}
 
export const AddBlockDialog = ({ isOpen, onOpenChange, onAddBlock }: AddBlockDialogProps) => {
  const handleAddBlock = (type: Block["type"]) => {
    onAddBlock(type);
    onOpenChange(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add Block</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-4 py-4">
          {Object.entries(blockConfig).map(([type, config]) => {
            const Icon = config.icon;
            return (
              <Button
                key={type}
                variant="outline"
                className="h-auto p-4 flex flex-col items-center gap-2"
                onClick={() => handleAddBlock(type as Block["type"])}
              >
                <Icon className="h-6 w-6" />
                <div className="text-sm font-medium">{config.label}</div>
                <div className="text-xs text-muted-foreground text-center">
                  {config.description}
                </div>
              </Button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
};
